import React from "react";

const PA = () => {
  return (
    <div className="PA">
      <div class="border-indigo-500 text-white bg-gradient-to-r from-blue-100 via-blue-500 to-blue-100 mt-8">
        <div class="pt-6 md:p-0 text-center md:text-center text-blue  -space-y-4">
          <p class="text-4xl p-5"> Publications </p>
        </div>
      </div>
      <figure class="flex  items-center justify-center p-8">
        <div class="box-content items-center justify-center h-30 w-11/12 p-4 border-transparent bg-blue-50 hover:shadow-lg hover:border-transparent ">
          <div class="h-full w-full border-2 bg-blue-50 over:bg-white hover:shadow-lg hover:border-transparent hover:bg-white">
            <br></br>
            <ul class="list-disc text-sm sm:text-lg md:text-2xl text-justify p-2">
              <li>
                T Thevathayarajh, KWSN Kumari and DDC Wanniarchchi (2019), “A
                digital device to monitor the colour changes during the
                fermentation stage of black tea processing”, Proceedings of
                International Conference on Recent Advances in Computer Science
                and Engineering (IC-RACE 2019), India (75-79).{" "}
              </li>
              <li>
                T Thevathayarajh, ARPCCJ Amarasinghe and RMTCB Ekanayake (2019),
                “A digital device to measure distance on multiple surfaces”,
                Proceedings of International Research Conference, Uva Wellassa
                University 2019,504.
              </li>
              <li>
                D.D.B. Senanayake, K.W.S.N Kumari and T. Thevathyarajh (2020),
                “Active and Passive Safety System for Differently Abled People
                and Adults”, Proceedings of International Research Conference,
                Uva Wellassa University 2020,195.
              </li>
              <li>
                T Thevathayarajh and DDC Wanniarachchi (2018), "Development of a
                monitoring device forfermentation stage of black tea
                manufacturing", Proceedings of 2nd International
                ResearchSymposium of Uva Wellassa University (IRSUWU 2018), 418.
              </li>
              <li>
                T.J. Danijal and T. Thevathayarajh (2021), "Development of
                Tracking over Speed System Using IoT Technology for
                Vehicles",Proceedings of International Research Conference, Uva
                Wellassa University 2021,139.
              </li>
              <li>
                K. Srikaran and T. Thevathayarajh (2021), "Development of IoT
                based tree cutting warning system in forests", Proceedings of
                3rd South Asia Conference on Interdisciplinary Research 2021,14.
              </li>
            </ul>
            <br></br>
          </div>
        </div>
      </figure>
      <div class="border-indigo-500 text-white bg-gradient-to-r from-blue-100 via-blue-500 to-blue-100">
        <div class="pt-6 md:p-0 text-center md:text-center text-blue  -space-y-4">
          <p class="text-4xl p-5"> Current Research and Projects </p>
        </div>
      </div>
      <figure class="flex  items-center justify-center p-8">
        <div class="box-content items-center justify-center h-30 w-11/12 p-4 border-transparent bg-blue-50 hover:shadow-lg hover:border-transparent ">
          <div class="h-full w-full border-2 bg-blue-50 over:bg-white hover:shadow-lg hover:border-transparent hover:bg-white">
            <br></br>
            <ul class="list-disc text-sm sm:text-lg md:text-2xl text-justify p-2">
              <li>IoT based medical instrumentation </li>
              <li>
                Development of Machine Learning algorithms for lower end
                microcontroller devices (LR){" "}
              </li>
            </ul>
            <br></br>
          </div>
        </div>
      </figure>
    </div>
  );
};

export default PA;
